import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {
    ArticleDto,
    BasketArticleDto,
    IBasketArticleDto,
    PagedResultDtoOfArticleDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';
import {tap} from 'rxjs/operators';
import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';

declare const abp: any; // Ensure "abp" global object is available

@Injectable({
    providedIn: 'root',
})
export class ProductNavigationService {

    // Observable for items which will be displayed
    private _items$: BehaviorSubject<BasketArticleDto[]>;
    // Observable for total amount of items
    private _totalAmount$: BehaviorSubject<number>;
    //Current page
    private _currentPage$: BehaviorSubject<number>;
    // Observable for  selected item which will be displayed
    private _selectedItem$: BehaviorSubject<BasketArticleDto>;

    constructor(injector: Injector) {

        this._currentPage$ = new BehaviorSubject<number>(0);

        this._totalAmount$ = new BehaviorSubject<number>(0);
        this._items$ = new BehaviorSubject<BasketArticleDto[]>(undefined);
        this._selectedItem$ = new BehaviorSubject<BasketArticleDto>(undefined);
    }

    //#region Current Page
    get currentPage(): number | null {
        return this._currentPage$.value;
    }

    get currentPage$(): Observable<number> {
        return this._currentPage$.asObservable();
    }

    setCurrentPage(currentPage: number): void {
        this._currentPage$.next(currentPage);
    }
    //#endregion Current Page

    //#region Products

    //#region Total Amount
    get totalAmount(): number {
        return this._totalAmount$.value;
    }

    get totalAmount$(): Observable<number> {
        return this._totalAmount$.asObservable();
    }

    setTotalAmount(result: number): void {
        this._totalAmount$.next(result);
    }
    //#endregion Total Amount

    //#region Items

    get items(): BasketArticleDto[] {
        return this._items$.value;
    }

    // Observable for viewMode
    get items$(): Observable<BasketArticleDto[]> {
        return this._items$.asObservable();
    }

    setItems(result: BasketArticleDto[]): void {
        this._items$.next(result);
    }
    //#endregion Items

    //#endregion Products

    //#region Selected Item
    get selectedItem(): BasketArticleDto | null {
        return this._selectedItem$.value;
    }

    get selectedItem$(): Observable<BasketArticleDto> {
        return this._selectedItem$.asObservable();
    }

    setSelectedItem(item: BasketArticleDto): void {
        this._selectedItem$.next(item);
    }

    get getCurrentItemIndex(): number {
        return this.items.findIndex((article) => article.id === this.selectedItem.id);
    }
    //#endregion Selected Item

}

